// ─── Carrier detection from tracking number format ───────────
// Based on official carrier tracking number patterns

export function detectCarrier(tracking) {
  const t = tracking.trim().toUpperCase().replace(/\s/g, "");

  if (!t) return null;

  // UPS
  if (/^1Z[A-Z0-9]{16}$/.test(t)) return { name: "UPS", color: "#8B4513", bg: "#FFF3E0", code: "UPS" };
  if (/^(T\d{10}|990\d{12}|996\d{12}|9\d{15})$/.test(t)) return { name: "UPS", color: "#8B4513", bg: "#FFF3E0", code: "UPS" };

  // FedEx
  if (/^\d{12}$/.test(t)) return { name: "FedEx", color: "#4A0E8F", bg: "#F3E5F5", code: "FEDEX" };
  if (/^\d{15}$/.test(t)) return { name: "FedEx", color: "#4A0E8F", bg: "#F3E5F5", code: "FEDEX" };
  if (/^\d{20}$/.test(t)) return { name: "FedEx", color: "#4A0E8F", bg: "#F3E5F5", code: "FEDEX" };
  if (/^96\d{20}$/.test(t)) return { name: "FedEx", color: "#4A0E8F", bg: "#F3E5F5", code: "FEDEX" };
  if (/^[0-9]{22}$/.test(t)) return { name: "FedEx", color: "#4A0E8F", bg: "#F3E5F5", code: "FEDEX" };

  // USPS
  if (/^9[234]\d{18}$/.test(t)) return { name: "USPS", color: "#1565C0", bg: "#E3F2FD", code: "USPS" };
  if (/^9[40]\d{18}$/.test(t)) return { name: "USPS", color: "#1565C0", bg: "#E3F2FD", code: "USPS" };
  if (/^(EA|EB|EC|ED|EE|CP|RA|RB|RC)[A-Z0-9]{9}US$/.test(t)) return { name: "USPS", color: "#1565C0", bg: "#E3F2FD", code: "USPS" };
  if (/^\d{22}$/.test(t)) return { name: "USPS", color: "#1565C0", bg: "#E3F2FD", code: "USPS" };
  if (/^82\d{8}$/.test(t)) return { name: "USPS", color: "#1565C0", bg: "#E3F2FD", code: "USPS" };

  // DHL
  if (/^\d{10,11}$/.test(t)) return { name: "DHL", color: "#B71C1C", bg: "#FFEBEE", code: "DHL" };
  if (/^[A-Z]{3}\d{7}$/.test(t)) return { name: "DHL", color: "#B71C1C", bg: "#FFEBEE", code: "DHL" };

  // Amazon
  if (/^TBA\d{12}$/.test(t)) return { name: "Amazon", color: "#E65100", bg: "#FFF8E1", code: "AMAZON" };

  return { name: "Unknown carrier", color: "#6b7280", bg: "#f3f4f6", code: "OTHER" };
}

export function getTrackingURL(tracking, carrierCode) {
  const t = tracking.trim();
  switch (carrierCode) {
    case "UPS":    return `https://www.ups.com/track?tracknum=${t}`;
    case "FEDEX":  return `https://www.fedex.com/fedextrack/?trknbr=${t}`;
    case "USPS":   return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${t}`;
    case "DHL":    return `https://www.dhl.com/en/express/tracking.html?AWB=${t}`;
    case "AMAZON": return `https://track.amazon.com/tracking/${t}`;
    default:       return null;
  }
}
